import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { AccountApprovalStateClass } from "./interfaces/AccountApprovalStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";
import { sortData } from "../../../common/timeLiveFunction";


const initialState: AccountApprovalStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    accountApprovalList: [],
    sortOrder: 'asc',
    sortColumn: 'ApprovalTypeName',
    search: '',
    pageNo: 1,
    pageSize: 10
}

interface IThunkApi {
    state: {
        accountApproval : AccountApprovalStateClass
    }
}

export const getAccountApprovalAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Approvals/V2/getAccountApproval",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            //const response = await fetchAPI("api/v2/EmployeeTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response=await fetchAPI('api/V2/Approvals/','Get', '', true,'0df3ab0c-4033-4013-8b1e-2f0b64f8cbab',)
            const json = response.json();
            return json;
        }

    )

export const getAccountApprovalByAccountApprovalTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Approvals/v2/getAccountApprovalByAccountApprovalTypeId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Approvals/Type/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
    export const getBlankDetailAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Approvals/v2/getBlankDetail",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Approvals/BlankDetail" , "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const addAccountApprovalTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Approvals/v2/addAccountApprovalType",
        async (arg, thunkApi) => {
            // const response = await fetchAPI("api/EmployeeTypes/","POST",arg,true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Approvals/", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const updateAccountApprovalTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Approvals/v2/updateAccountApprovalType",
        async (arg, thunkApi) => { 
            const { AccountApprovalTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI("api/v2/Approvals/" + AccountApprovalTypeId, "PUT", argWithoutId, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const deleteAccountApprovalTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Approvals/v2/deleteAccountEmployeeType",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Approvals/Type/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const DeleteSelectedAccountApprovalTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Approvals/v2/DeleteSelectedAccountApprovalType",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Approvals/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
    export const DeleteSelectedAccountApprovalPathAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Approvals/v2/DeleteSelectedAccountApprovalPath",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Approvals/DeleteSelected/Path/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

const accountApprovalSlice = createSlice({
    name: "accountApproval",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.accountApprovalList.findIndex((item : any) => item.AccountApprovalTypeId == action.payload);
            const newArray = [...state.accountApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.accountApprovalList = newArray;
            
        },
        unCheckedState: (state, action) => {
            const currentindex = state.accountApprovalList.findIndex((item) => item.AccountApprovalTypeId == action.payload);
            const newArray = [...state.accountApprovalList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.accountApprovalList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.accountApprovalList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.accountApprovalList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.accountApprovalList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.accountApprovalList = newArray;
           // state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.accountApprovalList;
            state.accountApprovalList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }


    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountApprovalAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountApprovalAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                //state.employeeTypeList = payload;
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.accountApprovalList = [];
                } else {
                    state.accountApprovalList = payload.Data;
                    state.accountApprovalList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountApprovalAsync.rejected, (state) => {
                state.status = "failed";
            })

            .addCase(getAccountApprovalByAccountApprovalTypeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountApprovalByAccountApprovalTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                
                if (Object.keys(payload.AccountApprovalType).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    payload.AccountApprovalPaths.map((item: any) => {
                        item.isSelected = 0
                    });
                    payload.AccountApprovalType[0].detail = payload.AccountApprovalPaths;
                    state.selectedRecord = payload.AccountApprovalType[0];
                }
                
            })
            .addCase(getAccountApprovalByAccountApprovalTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(getBlankDetailAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getBlankDetailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                if (Object.keys(payload.AccountApprovalPaths).length === 0) {
                    state.selectedRecord = {};
                } else {
                    payload.AccountApprovalPaths.map((item: any) => {
                        item.isSelected = 0
                    });
                    payload.AccountApprovalType[0].detail = payload.AccountApprovalPaths;
                    state.selectedRecord = payload.AccountApprovalType[0];
                }
            })
            .addCase(getBlankDetailAsync.rejected, (state) => {
                state.status = 'failed';
            })


            
            .addCase(addAccountApprovalTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountApprovalTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountApprovalTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountApprovalTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountApprovalTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                

            })
            .addCase(updateAccountApprovalTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountApprovalTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountApprovalTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountApprovalTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(DeleteSelectedAccountApprovalTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountApprovalTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
                
            })
            .addCase(DeleteSelectedAccountApprovalTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(DeleteSelectedAccountApprovalPathAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountApprovalPathAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //state.isReload = true;
                state.isLoading = false;
                
            })
            .addCase(DeleteSelectedAccountApprovalPathAsync.rejected, (state) => {
                state.status = 'failed';
            })
            
    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updateSorting, updatePagination } = accountApprovalSlice.actions
export const AccountApprovalState = (state: RootState) => state.accountApproval
export default accountApprovalSlice.reducer


